import { Team } from '../../../../../../types/sport';
import { ESPN_HEROS_BASE_URL } from '../../urls';
import { ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES } from './premier-league-player-images';

const BASE_FACE_URL = `${ESPN_HEROS_BASE_URL}/premier-league`;

export const ESPN_HERO_PREMIER_LEAGUE_TEAMS: Team[] = [
  {
    value: 'arsenal',
    label: 'Arsenal',
    players: [
      {
        value: 'bukayo-saka',
        label: 'Bukayo Saka',
        country: 'inglaterra',
        imageUrl: `${BASE_FACE_URL}/arsenal/bukayo-saka/face/Bukayo_Saka.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.arsenal['bukayo-saka']
      },
      {
        value: 'declan-rice',
        label: 'Declan Rice',
        country: 'inglaterra',
        imageUrl: `${BASE_FACE_URL}/arsenal/declan-rice/face/Declan_Rice.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.arsenal['declan-rice']
      },
      {
        value: 'gabriel-magalhaes',
        label: 'Gabriel Magalhães',
        country: 'brasil',
        imageUrl: `${BASE_FACE_URL}/arsenal/gabriel-magalhaes/face/Gabriel_Magalhaes.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.arsenal['gabriel-magalhaes']
      },
      {
        value: 'gabriel-martinelli',
        label: 'Gabriel Martinelli',
        country: 'brasil',
        imageUrl: `${BASE_FACE_URL}/arsenal/gabriel-martinelli/face/Gabriel_Martinelli.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.arsenal['gabriel-martinelli']
      },
      {
        value: 'piero-hincapie',
        label: 'Piero Hincapié',
        country: 'ecuador',
        imageUrl: `${BASE_FACE_URL}/arsenal/piero-hincapie/face/Hincapie.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.arsenal['piero-hincapie']
      },
      {
        value: 'martin-odegaard',
        label: 'Martin Ødegaard',
        country: 'noruega',
        imageUrl: `${BASE_FACE_URL}/arsenal/martin-odegaard/face/Martin_Odegaard.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.arsenal['martin-odegaard']
      },
      {
        value: 'viktor-gyokeres',
        label: 'Viktor Gyökeres',
        country: 'suecia',
        imageUrl: `${BASE_FACE_URL}/arsenal/viktor-gyokeres/face/Viktor_Gyökeres.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.arsenal['viktor-gyokeres']
      }
    ]
  },
  {
    value: 'aston-villa',
    label: 'Aston Villa',
    players: [
      {
        value: 'emiliano-buendia',
        label: 'Emiliano Buendía',
        country: 'argentina',
        imageUrl: `${BASE_FACE_URL}/aston-villa/emiliano-buendia/face/Emiliano_Buendia.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES['aston-villa']['emiliano-buendia']
      },
      {
        value: 'emiliano-martinez',
        label: 'Emiliano Martínez',
        country: 'argentina',
        imageUrl: `${BASE_FACE_URL}/aston-villa/emiliano-martinez/face/Emiliano_Martínez.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES['aston-villa']['emiliano-martinez']
      },
      {
        value: 'john-mcginn',
        label: 'John McGinn',
        country: 'escocia',
        imageUrl: `${BASE_FACE_URL}/aston-villa/john-mcginn/face/John_Mcginn.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES['aston-villa']['john-mcginn']
      },
      {
        value: 'ollie-watkins',
        label: 'Ollie Watkins',
        country: 'inglaterra',
        imageUrl: `${BASE_FACE_URL}/aston-villa/ollie-watkins/face/Ollie_Watkins.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES['aston-villa']['ollie-watkins']
      },
      {
        value: 'youri-tielemans',
        label: 'Youri Tielemans',
        country: 'belgica',
        imageUrl: `${BASE_FACE_URL}/aston-villa/youri-tielemans/face/Youri_Tielemans.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES['aston-villa']['youri-tielemans']
      }
    ]
  },
  {
    value: 'bournemouth',
    label: 'Bournemouth',
    players: [
      {
        value: 'alex-scott',
        label: 'Alex Scott',
        country: 'inglaterra',
        imageUrl: `${BASE_FACE_URL}/bournemouth/alex-scott/face/Alex_Scott.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.bournemouth['alex-scott']
      },
      {
        value: 'evanilson',
        label: 'Evanilson',
        country: 'brasil',
        imageUrl: `${BASE_FACE_URL}/bournemouth/evanilson/face/Evanilson.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.bournemouth['evanilson']
      },
      {
        value: 'julio-soler',
        label: 'Julio Soler',
        country: 'argentina',
        imageUrl: `${BASE_FACE_URL}/bournemouth/julio-soler/face/Julio_Soler.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.bournemouth['julio-soler']
      },
      {
        value: 'justin-kluivert',
        label: 'Justin Kluivert',
        country: 'paises_bajos',
        imageUrl: `${BASE_FACE_URL}/bournemouth/justin-kluivert/face/Justin_Kluivert.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.bournemouth['justin-kluivert']
      },
      {
        value: 'marcos-senesi',
        label: 'Marcos Senesi',
        country: 'argentina',
        imageUrl: `${BASE_FACE_URL}/bournemouth/marcos-senesi/face/Marcos_Senesi.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.bournemouth['marcos-senesi']
      },
      {
        value: 'tavernier',
        label: 'Tavernier',
        country: 'inglaterra',
        imageUrl: `${BASE_FACE_URL}/bournemouth/tavernier/face/Tavernier.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.bournemouth['tavernier']
      },
      {
        value: 'vitor-rayan',
        label: 'Vitor Rayan',
        country: 'brasil',
        imageUrl: `${BASE_FACE_URL}/bournemouth/vitor-rayan/face/Vitor_Rayan.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.bournemouth['vitor-rayan']
      }
    ]
  },
  {
    value: 'brentford',
    label: 'Brentford',
    players: [
      {
        value: 'fabio-carvalho',
        label: 'Fábio Carvalho',
        country: 'portugal',
        imageUrl: `${BASE_FACE_URL}/brentford/fabio-carvalho/face/Fabio_Carvalho.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.brentford['fabio-carvalho']
      },
      {
        value: 'igor-thiago',
        label: 'Igor Thiago',
        country: 'brasil',
        imageUrl: `${BASE_FACE_URL}/brentford/igor-thiago/face/Igor_Thiago.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.brentford['igor-thiago']
      },
      {
        value: 'jordan-henderson',
        label: 'Jordan Henderson',
        country: 'inglaterra',
        imageUrl: `${BASE_FACE_URL}/brentford/jordan-henderson/face/Jordan_Henderson.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.brentford['jordan-henderson']
      },
      {
        value: 'kevin-schade',
        label: 'Kevin Schade',
        country: 'alemania',
        imageUrl: `${BASE_FACE_URL}/brentford/kevin-schade/face/Kevin_Schade.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.brentford['kevin-schade']
      }
    ]
  },
  {
    value: 'brighton',
    label: 'Brighton',
    players: [
      {
        value: 'diego-gomez',
        label: 'Diego Gómez',
        country: 'paraguay',
        imageUrl: `${BASE_FACE_URL}/brighton/diego-gomez/face/Diego_Gómez.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.brighton['diego-gomez']
      },
      {
        value: 'james-milner',
        label: 'James Milner',
        country: 'inglaterra',
        imageUrl: `${BASE_FACE_URL}/brighton/james-milner/face/James_Milner.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.brighton['james-milner']
      },
      {
        value: 'kaoru-mitoma',
        label: 'Kaoru Mitoma',
        country: 'japon',
        imageUrl: `${BASE_FACE_URL}/brighton/kaoru-mitoma/face/Kaoru_Mitoma.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.brighton['kaoru-mitoma']
      },
      {
        value: 'kostoulas',
        label: 'Kostoulas',
        country: 'grecia',
        imageUrl: `${BASE_FACE_URL}/brighton/kostoulas/face/Kostoulas.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.brighton['kostoulas']
      }
    ]
  },
  {
    value: 'burnley',
    label: 'Burnley',
    players: [
      {
        value: 'armando-borja',
        label: 'Armando Borja',
        country: 'ecuador',
        imageUrl: `${BASE_FACE_URL}/burnley/armando-borja/face/Armando_Borja.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.burnley['armando-borja']
      },
      {
        value: 'jacob-bruun-larsen',
        label: 'Jacob Bruun Larsen',
        country: 'dinamarca',
        imageUrl: `${BASE_FACE_URL}/burnley/jacob-bruun-larsen/face/Jacob_Bruun_Larsen.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.burnley['jacob-bruun-larsen']
      },
      {
        value: 'kyle-walker',
        label: 'Kyle Walker',
        country: 'inglaterra',
        imageUrl: `${BASE_FACE_URL}/burnley/kyle-walker/face/Kyle_Walker.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.burnley['kyle-walker']
      },
      {
        value: 'marcus-edwards',
        label: 'Marcus Edwards',
        country: 'gales',
        imageUrl: `${BASE_FACE_URL}/burnley/marcus-edwards/face/Marcus_Edwards.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.burnley['marcus-edwards']
      }
    ]
  },
  {
    value: 'chelsea',
    label: 'Chelsea',
    players: [
      {
        value: 'cole-palmer',
        label: 'Cole Palmer',
        country: 'inglaterra',
        imageUrl: `${BASE_FACE_URL}/chelsea/cole-palmer/face/Cole-Palmer.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.chelsea['cole-palmer']
      },
      {
        value: 'enzo-fernandez',
        label: 'Enzo Fernández',
        country: 'argentina',
        imageUrl: `${BASE_FACE_URL}/chelsea/enzo-fernandez/face/Enzo-Fernandez.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.chelsea['enzo-fernandez']
      },
      {
        value: 'estevao',
        label: 'Estêvão',
        country: 'brasil',
        imageUrl: `${BASE_FACE_URL}/chelsea/estevao/face/Estevao.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.chelsea['estevao']
      },
      {
        value: 'garnacho',
        label: 'Garnacho',
        country: 'argentina',
        imageUrl: `${BASE_FACE_URL}/chelsea/garnacho/face/Garnacho.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.chelsea['garnacho']
      },
      {
        value: 'joao-pedro',
        label: 'João Pedro',
        country: 'brasil',
        imageUrl: `${BASE_FACE_URL}/chelsea/joao-pedro/face/Joao-Pedro.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.chelsea['joao-pedro']
      },
      {
        value: 'moises-caicedo',
        label: 'Moisés Caicedo',
        country: 'ecuador',
        imageUrl: `${BASE_FACE_URL}/chelsea/moises-caicedo/face/Moisés-Caicedo.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.chelsea['moises-caicedo']
      }
    ]
  },
  {
    value: 'crystal-palace',
    label: 'Crystal Palace',
    players: [
      {
        value: 'daniel-munoz',
        label: 'Daniel Muñoz',
        country: 'colombia',
        imageUrl: `${BASE_FACE_URL}/crystal-palace/daniel-munoz/face/Daniel-Muñoz.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES['crystal-palace']['daniel-munoz']
      },
      {
        value: 'ismaila-sarr',
        label: 'Ismaila Sarr',
        country: 'senegal',
        imageUrl: `${BASE_FACE_URL}/crystal-palace/ismaila-sarr/face/Ismaila-Sarr.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES['crystal-palace']['ismaila-sarr']
      },
      {
        value: 'jean-philippe-mateta',
        label: 'Jean-Philippe Mateta',
        country: 'francia',
        imageUrl: `${BASE_FACE_URL}/crystal-palace/jean-philippe-mateta/face/Jean-Philippe-Mateta.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES['crystal-palace']['jean-philippe-mateta']
      },
      {
        value: 'jefferson-lerma',
        label: 'Jefferson Lerma',
        country: 'colombia',
        imageUrl: `${BASE_FACE_URL}/crystal-palace/jefferson-lerma/face/Jefferson-Lerma.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES['crystal-palace']['jefferson-lerma']
      }
    ]
  },
  {
    value: 'everton',
    label: 'Everton',
    players: [
      {
        value: 'beto',
        label: 'Beto',
        country: 'portugal',
        imageUrl: `${BASE_FACE_URL}/everton/beto/face/Beto.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.everton['beto']
      },
      {
        value: 'carlos-alcaraz',
        label: 'Carlos Alcaraz',
        country: 'argentina',
        imageUrl: `${BASE_FACE_URL}/everton/carlos-alcaraz/face/Carlos-Alcaraz.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.everton['carlos-alcaraz']
      },
      {
        value: 'iliman-ndiaye',
        label: 'Iliman Ndiaye',
        country: 'senegal',
        imageUrl: `${BASE_FACE_URL}/everton/iliman-ndiaye/face/Iliman-Ndiaye.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.everton['iliman-ndiaye']
      },
      {
        value: 'jack-grealish',
        label: 'Jack Grealish',
        country: 'inglaterra',
        imageUrl: `${BASE_FACE_URL}/everton/jack-grealish/face/Jack-Grealish.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.everton['jack-grealish']
      },
      {
        value: 'james-tarkowski',
        label: 'James Tarkowski',
        country: 'inglaterra',
        imageUrl: `${BASE_FACE_URL}/everton/james-tarkowski/face/James-Tarkowski.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.everton['james-tarkowski']
      }
    ]
  },
  {
    value: 'fulham',
    label: 'Fulham',
    players: [
      {
        value: 'adama-traore',
        label: 'Adama Traoré',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/fulham/adama-traore/face/Adama-Traoré.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.fulham['adama-traore']
      },
      {
        value: 'alex-iwobi',
        label: 'Alex Iwobi',
        country: 'nigeria',
        imageUrl: `${BASE_FACE_URL}/fulham/alex-iwobi/face/Alex-Iwobi.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.fulham['alex-iwobi']
      },
      {
        value: 'kevin',
        label: 'Kevin',
        country: 'brasil',
        imageUrl: `${BASE_FACE_URL}/fulham/kevin/face/Kevin.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.fulham['kevin']
      },
      {
        value: 'raul-gimenez',
        label: 'Raúl Giménez',
        country: 'mexico',
        imageUrl: `${BASE_FACE_URL}/fulham/raul-gimenez/face/Raúl-Gimenez.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.fulham['raul-gimenez']
      },
      {
        value: 'rodrigo-muniz',
        label: 'Rodrigo Muniz',
        country: 'brasil',
        imageUrl: `${BASE_FACE_URL}/fulham/rodrigo-muniz/face/Rodrigo-Muniz.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.fulham['rodrigo-muniz']
      }
    ]
  },
  {
    value: 'leeds',
    label: 'Leeds',
    players: [
      {
        value: 'brenden-aaronson',
        label: 'Brenden Aaronson',
        country: 'usa',
        imageUrl: `${BASE_FACE_URL}/leeds/brenden-aaronson/face/Brenden-Aaronson.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.leeds['brenden-aaronson']
      },
      {
        value: 'buonanotte',
        label: 'Buonanotte',
        country: 'argentina',
        imageUrl: `${BASE_FACE_URL}/leeds/buonanotte/face/Buonanotte.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.leeds['buonanotte']
      },
      {
        value: 'dominic-calvert-lewin',
        label: 'Dominic Calvert-Lewin',
        country: 'inglaterra',
        imageUrl: `${BASE_FACE_URL}/leeds/dominic-calvert-lewin/face/Dominic-Calvert-Lewin.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.leeds['dominic-calvert-lewin']
      },
      {
        value: 'lukas-nmecha',
        label: 'Lukas Nmecha',
        country: 'alemania',
        imageUrl: `${BASE_FACE_URL}/leeds/lukas-nmecha/face/Lukas-Nmecha.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.leeds['lukas-nmecha']
      }
    ]
  },
  {
    value: 'liverpool',
    label: 'Liverpool',
    players: [
      {
        value: 'alexis-mac-allister',
        label: 'Alexis Mac Allister',
        country: 'argentina',
        imageUrl: `${BASE_FACE_URL}/liverpool/alexis-mac-allister/face/Alexis-Mac-Allister.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.liverpool['alexis-mac-allister']
      },
      {
        value: 'cody-gakpo',
        label: 'Cody Gakpo',
        country: 'paises_bajos',
        imageUrl: `${BASE_FACE_URL}/liverpool/cody-gakpo/face/Cody-Gakpo.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.liverpool['cody-gakpo']
      },
      {
        value: 'dominik-szoboszlai',
        label: 'Dominik Szoboszlai',
        country: 'hungria',
        imageUrl: `${BASE_FACE_URL}/liverpool/dominik-szoboszlai/face/Dominik-Szoboszlai.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.liverpool['dominik-szoboszlai']
      },
      {
        value: 'mohamed-salah',
        label: 'Mohamed Salah',
        country: 'egipto',
        imageUrl: `${BASE_FACE_URL}/liverpool/mohamed-salah/face/Mohamed-Salah.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.liverpool['mohamed-salah']
      },
      {
        value: 'virgil-van-dijk',
        label: 'Virgil Van Dijk',
        country: 'paises_bajos',
        imageUrl: `${BASE_FACE_URL}/liverpool/virgil-van-dijk/face/Virgil-Van-Dijk.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.liverpool['virgil-van-dijk']
      }
    ]
  },
  {
    value: 'manchester-city',
    label: 'Manchester City',
    players: [
      {
        value: 'bernardo-silva',
        label: 'Bernardo Silva',
        country: 'portugal',
        imageUrl: `${BASE_FACE_URL}/manchester-city/bernardo-silva/face/Bernardo-Silva.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES['manchester-city']['bernardo-silva']
      },
      {
        value: 'erling-haaland',
        label: 'Erling Haaland',
        country: 'noruega',
        imageUrl: `${BASE_FACE_URL}/manchester-city/erling-haaland/face/Erling-Haaland.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES['manchester-city']['erling-haaland']
      },
      {
        value: 'omar-marmoush',
        label: 'Omar Marmoush',
        country: 'egipto',
        imageUrl: `${BASE_FACE_URL}/manchester-city/omar-marmoush/face/Omar-Marmoush.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES['manchester-city']['omar-marmoush']
      },
      {
        value: 'phil-foden',
        label: 'Phil Foden',
        country: 'inglaterra',
        imageUrl: `${BASE_FACE_URL}/manchester-city/phil-foden/face/Phil-Foden.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES['manchester-city']['phil-foden']
      },
      {
        value: 'rodri',
        label: 'Rodri',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/manchester-city/rodri/face/Rodri.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES['manchester-city']['rodri']
      }
    ]
  },
  {
    value: 'manchester-united',
    label: 'Manchester United',
    players: [
      {
        value: 'bruno-fernandes',
        label: 'Bruno Fernandes',
        country: 'portugal',
        imageUrl: `${BASE_FACE_URL}/manchester-united/bruno-fernandes/face/Bruno-Fernandes.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES['manchester-united']['bruno-fernandes']
      },
      {
        value: 'bryan-mbeumo',
        label: 'Bryan Mbeumo',
        country: 'camerun',
        imageUrl: `${BASE_FACE_URL}/manchester-united/bryan-mbeumo/face/Bryan-Mbeumo.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES['manchester-united']['bryan-mbeumo']
      },
      {
        value: 'casemiro',
        label: 'Casemiro',
        country: 'brasil',
        imageUrl: `${BASE_FACE_URL}/manchester-united/casemiro/face/Casemiro.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES['manchester-united']['casemiro']
      },
      {
        value: 'lisandro-martinez',
        label: 'Lisandro Martínez',
        country: 'argentina',
        imageUrl: `${BASE_FACE_URL}/manchester-united/lisandro-martinez/face/Lisandro-Martínez.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES['manchester-united']['lisandro-martinez']
      },
      {
        value: 'manuel-ugarte',
        label: 'Manuel Ugarte',
        country: 'uruguay',
        imageUrl: `${BASE_FACE_URL}/manchester-united/manuel-ugarte/face/Manuel-Ugarte.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES['manchester-united']['manuel-ugarte']
      },
      {
        value: 'matheus-cunha',
        label: 'Matheus Cunha',
        country: 'brasil',
        imageUrl: `${BASE_FACE_URL}/manchester-united/matheus-cunha/face/Matheus-Cunha.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES['manchester-united']['matheus-cunha']
      }
    ]
  },
  {
    value: 'newcastle',
    label: 'Newcastle',
    players: [
      {
        value: 'anthony-gordon',
        label: 'Anthony Gordon',
        country: 'inglaterra',
        imageUrl: `${BASE_FACE_URL}/newcastle/anthony-gordon/face/Anthony-Gordon.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.newcastle['anthony-gordon']
      },
      {
        value: 'bruno-guimaraes',
        label: 'Bruno Guimarães',
        country: 'brasil',
        imageUrl: `${BASE_FACE_URL}/newcastle/bruno-guimaraes/face/Bruno-Guimarães.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.newcastle['bruno-guimaraes']
      },
      {
        value: 'joelinton',
        label: 'Joelinton',
        country: 'brasil',
        imageUrl: `${BASE_FACE_URL}/newcastle/joelinton/face/Joelinton.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.newcastle['joelinton']
      },
      {
        value: 'nick-woltemade',
        label: 'Nick Woltemade',
        country: 'alemania',
        imageUrl: `${BASE_FACE_URL}/newcastle/nick-woltemade/face/Nick-Woltemade.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.newcastle['nick-woltemade']
      },
      {
        value: 'sandro-tonali',
        label: 'Sandro Tonali',
        country: 'italia',
        imageUrl: `${BASE_FACE_URL}/newcastle/sandro-tonali/face/Sandro-Tonali.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.newcastle['sandro-tonali']
      }
    ]
  },
  {
    value: 'nottingham-forest',
    label: 'Nottingham Forest',
    players: [
      {
        value: 'chris-wood',
        label: 'Chris Wood',
        country: 'nueva_zelanda',
        imageUrl: `${BASE_FACE_URL}/nottingham-forest/chris-wood/face/Chris-Wood.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES['nottingham-forest']['chris-wood']
      },
      {
        value: 'igor-jesus',
        label: 'Igor Jesus',
        country: 'brasil',
        imageUrl: `${BASE_FACE_URL}/nottingham-forest/igor-jesus/face/Igor-Jesus.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES['nottingham-forest']['igor-jesus']
      },
      {
        value: 'morgan-gibbs-white',
        label: 'Morgan Gibbs-White',
        country: 'inglaterra',
        imageUrl: `${BASE_FACE_URL}/nottingham-forest/morgan-gibbs-white/face/Morgan-Gibbs-White.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES['nottingham-forest']['morgan-gibbs-white']
      },
      {
        value: 'murillo',
        label: 'Murillo',
        country: 'brasil',
        imageUrl: `${BASE_FACE_URL}/nottingham-forest/murillo/face/Murillo.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES['nottingham-forest']['murillo']
      },
      {
        value: 'nicolas-dominguez',
        label: 'Nicolás Domínguez',
        country: 'argentina',
        imageUrl: `${BASE_FACE_URL}/nottingham-forest/nicolas-dominguez/face/Nicolas-Domínguez.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES['nottingham-forest']['nicolas-dominguez']
      }
    ]
  },
  {
    value: 'sunderland',
    label: 'Sunderland',
    players: [
      {
        value: 'brian-brobbey',
        label: 'Brian Brobbey',
        country: 'paises_bajos',
        imageUrl: `${BASE_FACE_URL}/sunderland/brian-brobbey/face/Brian-Brobbey.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.sunderland['brian-brobbey']
      },
      {
        value: 'granit-xhaka',
        label: 'Granit Xhaka',
        country: 'suiza',
        imageUrl: `${BASE_FACE_URL}/sunderland/granit-xhaka/face/Granit-Xhaka.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.sunderland['granit-xhaka']
      },
      {
        value: 'omar-alderete',
        label: 'Omar Alderete',
        country: 'paraguay',
        imageUrl: `${BASE_FACE_URL}/sunderland/omar-alderete/face/Omar-Alderete.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.sunderland['omar-alderete']
      }
    ]
  },
  {
    value: 'tottenham',
    label: 'Tottenham',
    players: [
      {
        value: 'cuti-romero',
        label: 'Cuti Romero',
        country: 'argentina',
        imageUrl: `${BASE_FACE_URL}/tottenham/cuti-romero/face/Cuti-Romero.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.tottenham['cuti-romero']
      },
      {
        value: 'dominic-solanke',
        label: 'Dominic Solanke',
        country: 'inglaterra',
        imageUrl: `${BASE_FACE_URL}/tottenham/dominic-solanke/face/Dominic-Solanke.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.tottenham['dominic-solanke']
      },
      {
        value: 'joao-palinha',
        label: 'João Palhinha',
        country: 'portugal',
        imageUrl: `${BASE_FACE_URL}/tottenham/joao-palinha/face/Joao-Palinha.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.tottenham['joao-palinha']
      },
      {
        value: 'richarlison',
        label: 'Richarlison',
        country: 'brasil',
        imageUrl: `${BASE_FACE_URL}/tottenham/richarlison/face/Richarlison.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.tottenham['richarlison']
      },
      {
        value: 'rodrigo-bentancur',
        label: 'Rodrigo Bentancur',
        country: 'uruguay',
        imageUrl: `${BASE_FACE_URL}/tottenham/rodrigo-bentancur/face/Rodrigo-Bentancur.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.tottenham['rodrigo-bentancur']
      },
      {
        value: 'xavi-simons',
        label: 'Xavi Simons',
        country: 'paises_bajos',
        imageUrl: `${BASE_FACE_URL}/tottenham/xavi-simons/face/Xavi-Simons.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.tottenham['xavi-simons']
      }
    ]
  },
  {
    value: 'wolverhampton',
    label: 'Wolverhampton',
    players: [
      {
        value: 'jhon-arias',
        label: 'Jhon Arias',
        country: 'colombia',
        imageUrl: `${BASE_FACE_URL}/wolverhampton/jhon-arias/face/Jhon-Arias.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.wolverhampton['jhon-arias']
      },
      {
        value: 'joao-gomes',
        label: 'João Gomes',
        country: 'brasil',
        imageUrl: `${BASE_FACE_URL}/wolverhampton/joao-gomes/face/Joao-Gomes.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.wolverhampton['joao-gomes']
      },
      {
        value: 'jorgen-strand-larsen',
        label: 'Jørgen Strand Larsen',
        country: 'noruega',
        imageUrl: `${BASE_FACE_URL}/wolverhampton/jorgen-strand-larsen/face/Jorgen-Strand-Larsen.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.wolverhampton['jorgen-strand-larsen']
      },
      {
        value: 'santiago-bueno',
        label: 'Santiago Bueno',
        country: 'uruguay',
        imageUrl: `${BASE_FACE_URL}/wolverhampton/santiago-bueno/face/Santiago-Bueno.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.wolverhampton['santiago-bueno']
      },
      {
        value: 'yerson-mosquera',
        label: 'Yerson Mosquera',
        country: 'colombia',
        imageUrl: `${BASE_FACE_URL}/wolverhampton/yerson-mosquera/face/Yerson-Mosquera.png`,
        images: ESPN_HERO_PREMIER_LEAGUE_PLAYER_IMAGES.wolverhampton['yerson-mosquera']
      }
    ]
  }
];
